(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fingies-product-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fingies-tabs')) {
    class FingiesTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll(':scope > .fp-tab > [role="tab"]'));
        if (!this.tabs.length) return;

        const list = document.createElement('div');
        list.className = 'fp-tabs__list';
        list.setAttribute('role', 'tablist');
        this.tabs.forEach((tab) => list.append(tab));
        this.prepend(list);

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index, false));
          tab.addEventListener('keydown', (event) => this.onKey(event, index));
        });

        this.onBlockSelect = (event) => {
          const index = this.tabs.findIndex((tab) => tab.dataset.blockId === event.detail.blockId);
          if (index > -1) this.select(index, false);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.select(0, false);
        this.dataset.ready = '';
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      select(index, focus) {
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (panel) panel.classList.toggle('is-active', active);
        });
        if (focus) this.tabs[index].focus();
      }

      onKey(event, index) {
        const last = this.tabs.length - 1;
        let next = null;
        if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
        if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = last;
        if (next === null) return;
        event.preventDefault();
        this.select(next, true);
      }
    }

    customElements.define('fingies-tabs', FingiesTabs);
  }
  } catch(e) { console.error(e); }
})();

})();
